import path from 'path';
import { fileURLToPath } from 'url';
import { isExternalPackage, resolve } from '@ms-cloudpack/path-utilities';

/**
 * Resolves an internal Cloudpack package path, ensuring we use the bundled version when available.
 *
 */
export async function resolveCloudpackInternalPath(params: {
  packageName: string;
  importMetaUrl: string;
}): Promise<string | undefined> {
  const { packageName, importMetaUrl } = params;
  const currentDir = path.dirname(fileURLToPath(importMetaUrl));
  let packagePath = await resolve(packageName, currentDir);

  // If the package is internal, resolve it from the CLI's node_modules
  // to "externalize" it, so that we always use the bundled version instead of the source.
  if (packagePath && !isExternalPackage(packagePath)) {
    const cliPath = await resolve('@ms-cloudpack/cli', currentDir);
    packagePath = cliPath ? path.join(cliPath, 'node_modules', packageName) : undefined;
  }

  return packagePath;
}
